import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../../../Components/Layout";
import Addons from "../../../Components/EventMgt/CreateEvent/Addons";

const AddonsPage = () => {
  const params = useParams();
  const { eventId } = params;
  const location = useLocation();
  const navigate = useNavigate();
  const [showAddonModal, setShowAddonModal] = useState(false);

  useEffect(() => {
    if (
      eventId === "undefined" ||
      eventId === undefined ||
      eventId === null ||
      !eventId
    ) {
      navigate("/");
    }
  }, [location, eventId, navigate]);

  const query = new URLSearchParams(window.location.search);
  const redirectUrl = query.get("redirectUrl");

  return (
    <Layout
      BackAction={redirectUrl}
      Heading="Add-ons"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head event-create-head--split"
      CreateHead
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
      extraElement={
        <button
          className="event-addons-header-btn"
          type="button"
          onClick={() => setShowAddonModal(true)}
        >
          Create Add-on
        </button>
      }
    >
      <Addons
        showAddonModal={showAddonModal}
        setShowAddonModal={setShowAddonModal}
        onCloseAddonModal={() => setShowAddonModal(false)}
      />
    </Layout>
  );
};

export default AddonsPage;
